import { forwardRef } from "react"
import { Stack, StackProps } from "@chakra-ui/react"

export const Section = forwardRef<HTMLDivElement, StackProps>((props, ref) => {
  return (
    <Stack
      ref={ref}
      w="100%"
      pl={10}
      pr={10}
      pt={5}
      pb={10}
      gap={0}
      {...props}
    />
  )
})